import { z } from "zod";

import { gameStateEnum } from "./home/triviaSchema";
import { imagesSchema } from "./imagesSchema";

export const wordSchema = z.object({
  available_at: z.string().datetime(),
  ends_at: z.string().datetime().nullable(),
  explanation: z.string().optional(),
  id: z.number(),
  images: imagesSchema,
  is_in_routine: z.boolean().optional(),
  player_count: z.number(),
  state: gameStateEnum,
  summary: z.object({
    guess_distribution: z
      .record(z.number().or(z.string()), z.number())
      .nullable(),
    guesses: z.string().array().optional(),
    longest_streak: z.number(),
    streak: z.number(),
    win_percentage: z.number(),
    matrix: z
      .array(z.array(z.enum(["in_word", "in_word_in_position", "not_in_word"])))
      .optional(),
  }),
  word: z.string(),
});

export type TheWordGame = z.infer<typeof wordSchema>;
